$(".js-slider").length && $(".js-slider").slick({
    infinite: true,
    speed: 700,
    autoplay: true,
    fade: true,
    autoplaySpeed: 4000,
    arrows: false
});
$('.js-slider--swipe').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  dots: true,
  arrows: true,
  adaptiveHeight: true
});
$('.js-slider--swipe-autoplay').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  dots: true,
  arrows: true,
  infinite: true,
  cssEase: 'linear'
});